<template>
  <FormContainer v-if="store.estDossier">
    <template #title>Documents du dossier DRF</template>
    <template #content>
      <basic-alert
        v-if="store.meta?.drf?.courriers?.$messageErreur"
        :alert-label="store.meta?.drf?.courriers?.$messageErreur"
      />
      <CourriersList
        :courriers="store.model?.drf?.courriers ?? []"
        :code="store.model?.contrat?.codeDrf!"
        endpoint="reservationsfonds"
        style="padding: 0"
      >
        <template #after-title>
          <div class="flex flex-gap-2">
            <!-- A conserver pour debug du rechargement -->
            <!--
            <BasicButton
              @click="docRefreshService.notifyEnvoieCourrier"
              type="reverse"
              iconName="location"
              style="display: inline; margin-top: -3px"
            />
            -->
            <BasicTooltip label="Recharger la liste des documents">
              <BasicButton
                @click="docRefreshService.forceRaffraichissement()"
                type="reverse"
                iconName="filter-remove"
                style="display: inline; margin-top: -3px"
              />
            </BasicTooltip>
            <DocumentsList
              :code="store.model?.contrat?.codeDrf!"
              :dispositif="store.model!.dispositif!"
              endpoint="reservationsfonds"
              :pieces="[]"
              :statut="store.model?.drf?.statut!"
              :natures-authorisees="store.model?.drf?.naturesPiecesDeposables"
              mode="upload"
              @upload-success="docRefreshService.notifyEnvoieCourrier"
            />
          </div>
        </template>
      </CourriersList>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared/components'
  import { inject } from 'vue'
  import CourriersList from '@/features/interface/detail/components/CourriersList.vue'
  import DocumentsList from '@/features/interface/detail/components/DocumentsList.vue'
  import { CXPI_DOC_REFRESH } from '@/features/interface/demande/cxpi/useDocumentsRefreshCXPI.ts'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const docRefreshService = inject(CXPI_DOC_REFRESH)!
</script>

<style scoped lang="less"></style>
